export type CallClickData = {
  event: "call_click";
  phone_number: string;
  location: string;
  label?: string;
};

export function trackCallClick(location: string, label?: string) {
  const phoneNumber = "+916364894003";
  const payload: CallClickData = {
    event: "call_click",
    phone_number: phoneNumber,
    location,
    label: label || location,
  };

  if (typeof window !== "undefined") {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(payload);
  }
}
